/**
 * Fictora 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

export const theme = {
  // 引用装饰线颜色 (Fictora 使用粉色调,基于主色)
  quoteColor: 'rgba(255, 45, 137, 0.3)',
  // 目录弹窗中锁图标的颜色
  tocLockColor: '#ffffff',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
